import React, { useState, useEffect } from 'react';
import '../CSS/MarigoldBanquetHall.css';
import venueImage from '../assets/ContactHeaderImg.jpeg';
import { FaUtensils, FaWifi, FaParking, FaUsers, FaMusic, FaCamera, FaStar, FaMapMarkerAlt, FaCalendarAlt } from 'react-icons/fa';
import Header from './Header';
import Footer from './Footer';
import Contactbar from '../Components/ContactBar';

import KG1 from '../assets/LIBRA EVENTS/KSH_9662.jpg';
import KG2 from '../assets/LIBRA EVENTS/KSH_7844.jpg';
import KG3 from '../assets/LIBRA EVENTS/KSH_7687.jpg';
import KG4 from '../assets/LIBRA EVENTS/KSH_7487.jpg';
import KG5 from '../assets/LIBRA EVENTS/KSH_7197.jpg';
import KG6 from '../assets/LIBRA EVENTS/KSH_6339.jpg';
import KG7 from '../assets/LIBRA EVENTS/KSH_5218.jpg';
import KG8 from '../assets/LIBRA EVENTS/KSH_4829.jpg';
import KG9 from '../assets/LIBRA EVENTS/KSH_2988.jpg';



const MarigoldBanquetHall = () => {


  useEffect(() => {
      window.scrollTo(0, 0); // 👈 Scroll to top on page load
    }, []);
  

    const [selectedImage, setSelectedImage] = useState(null);
const openModal = (img) => setSelectedImage(img);
const closeModal = () => setSelectedImage(null);

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
 
  const handleSubmit = (e) => {
    e.preventDefault();
 
    const message = `*Venue Booking Request*\n\n*Name:* ${formData.name}\n*Email:* ${formData.email}\n*Phone:* ${formData.phone}\n*Message:* ${formData.message}`;
 
    const phoneNumber = '919909254684'; // 🔁 Replace with your WhatsApp number (with country code)
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
 
    window.open(url, '_blank');
 
    setShowModal(false); // Close modal
    setFormData({ name: '', email: '', phone: '', message: '' }); // Reset form
  };
  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="Marigold-hero" style={{ backgroundImage: `url(${venueImage})` }}>
        <div className="Marigold-hero-overlay">
          <h1>KB Patel PARTY PLOT</h1>
          <p>Premium Venue for Unforgettable Celebrations</p>
        </div>
      </section>

      {/* About Section */}
      <section className="Marigold-content">
        <div className="Marigold-details">
          <h2>About the Venue</h2>
          <p>
             Step into the expansive and enchanting world of KB Patel Party Plot, where grand outdoor celebrations come to life under the open skies of Vadodara. More than just a venue, our party plot is a sprawling canvas designed to host unforgettable weddings, vibrant receptions, large-scale corporate gatherings, and any special occasion demanding an impressive, open-air setting.
  <br/><br/>
We’ve cultivated KB Patel Party Plot to offer a harmonious blend of natural beauty and modern convenience. Our vast, meticulously maintained green spaces provide a naturally luxurious ambiance, allowing your guests to breathe freely and celebrate amidst the fresh air. While embracing the outdoors, we ensure your event benefits from essential amenities including dedicated lighting for evening affairs, quality sound systems to keep the energy high, and ample, easily accessible parking.
  <br/><br/>
Our dedicated team of event specialists understands the unique dynamics of outdoor celebrations. From the initial concept to the final flourish, they work tirelessly to bring your vision to life. The versatile layout of KB Patel Party Plot can be transformed to perfectly match your theme and guest count, whether you’re planning a magnificent gala for a thousand or a charming, intimate gathering for a hundred.
  <br/><br/>
Beyond the stunning setting, we offer flexible catering options to tantalize every palate and a warm, welcoming atmosphere that encourages joyful connections. We believe in providing a stress-free planning journey, allowing you to fully immerse yourself in the magic of your special day.
  <br/><br/>
Come and explore KB Patel Party Plot. Discover how our open-air elegance can turn your event ideas into grand, cherished memories that sparkle under the sun or the stars.
</p>
          

          <h3>Key Features</h3>
          <div className="Marigold-features">
            <div className="Marigold-feature-item"><FaUsers className="icon" /> 1000 Guest Capacity</div>
            <div className="Marigold-feature-item"><FaParking className="icon" /> Standard Parking</div>
            <div className="Marigold-feature-item"><FaWifi className="icon" /> High-Speed WiFi</div>
            <div className="Marigold-feature-item"><FaUtensils className="icon" /> Premium Catering</div>
            <div className="Marigold-feature-item"><FaMusic className="icon" /> Sound System</div>
            <div className="Marigold-feature-item"><FaCamera className="icon" /> Photo Zones</div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
<section className="Marigold-gallery">
  <h2>Venue Gallery</h2>
  <div className="gallery-grid">
    {[
        KG1,
        KG2,
        KG3,
        KG4,
        KG5,
        KG6,
        KG7,
        KG8,
        KG9
    ].map((img, index) => (
      <div key={index} className="gallery-item">
        <img src={img} alt={`Gallery ${index + 1}`} onClick={() => openModal(img)} />
      </div>
    ))}
  </div>

  {/* Modal */}
  {selectedImage && (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <img src={selectedImage} alt="Zoomed" />
        <span className="modal-close" onClick={closeModal}>&times;</span>
      </div>
    </div>
  )}
</section>

      {/* Event Types Section */}
      <section className="Marigold-events">
        <h2>Perfect For All Occasions</h2>
        <div className="event-types">
          <div><FaCalendarAlt /> Weddings</div>
          <div><FaCalendarAlt /> Engagements</div>
          <div><FaCalendarAlt /> Corporate Seminars</div>
          <div><FaCalendarAlt /> Birthday Parties</div>
          <div><FaCalendarAlt /> Anniversary Celebrations</div>
        </div>
      </section>

      {/* Amenities Section */}
      <section className="Marigold-amenities">
        <h2>Amenities</h2>
        <ul className="amenities-list">
            <li>Air-conditioned Hall</li>
            <li>Standard Parking</li>
            <li>High-Speed Wi-Fi</li>
            <li>Stage and Lighting</li>
            <li>On-Site Catering</li>
            <li>Changing Rooms</li>
            <li>Backup Power Supply</li>
            <li>Audio Visual Equipment</li>
            <li>Dedicated Event Manager</li>
            <li>Security Staff</li>
            <li>Luxury Washrooms</li>
            <li>Photobooth Area</li>
        </ul>
    </section>


      {/* Why Choose Us */}
      <section className="Marigold-why-choose">
        <h2>Why Choose KB Patel Party Plot ?</h2>
        <p>
           With our blend of luxury, service, and technology, we offer a truly premium experience. Our team ensures that every event is stress-free,
  beautifully executed, and memorable for both hosts and guests.
  <br/><br/>
  From personalized décor themes to gourmet catering, we tailor every detail to match your vision and style. Our staff is trained to deliver impeccable hospitality,
  making sure your guests feel welcomed and cared for throughout the event.
  <br/><br/>
  With ample parking space, flexible seating arrangements, and cutting-edge facilities, we go above and beyond to create an unforgettable experience
  that exceeds expectations.
        </p>
        <div className="reasons">
          <div><FaStar /> Trusted by Thousands of Clients</div>
          <div><FaStar /> Centrally Located</div>
          <div><FaStar /> Highly Rated Service</div>
          <div><FaStar /> Tailored Packages Available</div>
        </div>
      </section>

      {/* Map/Location (optional image placeholder) */}
      <section className="Marigold-map">
        <h2>Our Location</h2>
        <div className="map-placeholder">
          <FaMapMarkerAlt className="map-icon" />
          <p> Basement, 1, Eva Mall Rd,
      near Saraswati Complex, <br/>
      Patidar Crossing, Manjalpur, 
      Vadodara, Gujarat 390011</p>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3692.130874232507!2d73.18579307427751!3d22.27303174388519!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc5dc2bde1cfd%3A0xa435e654a2557c24!2sEva%20Banquet!5e0!3m2!1sen!2sin!4v1748431747093!5m2!1sen!2sin"width="100%"
                height="300"
                allowFullScreen=""
                loading="lazy"
                title="Google Map Location"
                ></iframe>
        </div>
      </section>

      {/* Booking CTA */}
<div className="Marigold-cta-wrapper">
  <section className="Marigold-booking-cta">
    <h2>Ready to Book Your Event ?</h2>
    <p>Make your celebration unforgettable at KB Patel Party Plot. Contact us now to check availability and receive a customized quote for your special occasion.</p>
    <div className="cta-buttons">
      <button className="book-now" onClick={() => setShowModal(true)}>Book Now</button>
      <a href="/venues" className="contact">Back to Venues</a>
    </div>
  </section>
</div>

{/* Modal Section */}
      {showModal && (
  <div className="modal-overlay" onClick={() => setShowModal(false)}>
    <div className="modal-box" onClick={(e) => e.stopPropagation()}>
      <h3>Book Now</h3>
      <form className="modal-form" onSubmit={(e) => handleSubmit(e)}>
        <input
          type="text"
          placeholder="Your Name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          required
        />
        <input
          type="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          required
        />
        <input
          type="tel"
          placeholder="Your Phone"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          required
        />
        <textarea
          placeholder="Message / Special Requests"
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
        ></textarea>
        <div className="modal-actions">
          <button type="submit" className="submit-btn">Send</button>
          <button type="button" className="close-btn" onClick={() => setShowModal(false)}>Close</button>
        </div>
      </form>
    </div>
  </div>
)}

    <Contactbar/>
      <Footer />
    </>
  );
};

export default MarigoldBanquetHall;
